import {
  type UseOverviewAccountChartControllerParams,
  useOverviewAccountChartController,
} from "./OverviewAccountChart.controller";
import { OverviewAccountChartPresentation } from "./OverviewAccountChart.pres";

export type OverviewAccountChartProps = UseOverviewAccountChartControllerParams;

export const OverviewAccountChart = (
  props: OverviewAccountChartProps,
): JSX.Element => {
  const value = useOverviewAccountChartController(props);
  return <OverviewAccountChartPresentation {...value} />;
};
